import React from 'react';
import { COLORS, EDGE_WIDTH } from '../../lib/network/constants';
import { Marker } from './EdgeView';

/** The provisional link drawn while dragging from a node with a link tool. */
export default function ConnectionLine({ geometry }) {
  return (
    <g data-layer="connection" pointerEvents="none">
      <path d={geometry.path} fill="none" stroke={COLORS.highlight} strokeWidth={EDGE_WIDTH.normal} />
      <Marker marker={geometry.marker} color={COLORS.highlight} />
    </g>
  );
}
